import { baseApi } from '@/services/api';
import {
  Agent,
  AgentTask,
  AgentTaskRequest,
  OrchestrationRequest,
  AgentResponse,
  AgentStatus,
} from './agentsTypes';

export const agentsAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Agent System Status
    getAgentsStatus: builder.query<AgentStatus, void>({
      query: () => ({
        url: '/agents/status',
        method: 'GET',
      }),
      providesTags: ['Agents'],
    }),
    
    // List Available Agents
    listAvailableAgents: builder.query<{ agents: Agent[]; message?: string }, void>({
      query: () => ({
        url: '/agents/list',
        method: 'GET',
      }),
      providesTags: ['Agents'],
    }),
    
    // Orchestrate Multiple Agents
    orchestrateAgents: builder.mutation<AgentResponse, OrchestrationRequest>({
      query: (request) => ({
        url: '/agents/orchestrate',
        method: 'POST',
        data: request,
      }),
      invalidatesTags: ['AgentTasks'],
    }),
    
    // Code Generation (Coder Agent)
    generateCode: builder.mutation<AgentResponse, AgentTaskRequest>({
      query: (request) => ({
        url: '/agents/coder/generate',
        method: 'POST',
        data: request,
      }),
      invalidatesTags: ['AgentTasks', 'CodeGenerations'],
    }),
    
    // Test Generation (Tester Agent)
    generateTests: builder.mutation<AgentResponse, AgentTaskRequest>({
      query: (request) => ({
        url: '/agents/tester/generate',
        method: 'POST',
        data: request,
      }),
      invalidatesTags: ['AgentTasks'],
    }),
    
    // Deployment (Deployer Agent)
    deployProject: builder.mutation<AgentResponse, AgentTaskRequest>({
      query: (request) => ({
        url: '/agents/deployer/deploy',
        method: 'POST',
        data: request,
      }),
      invalidatesTags: ['AgentTasks', 'Deployments'],
    }),
    
    // Get Task Status
    getTaskStatus: builder.query<AgentTask, string>({
      query: (taskId) => ({
        url: `/agents/tasks/${taskId}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'AgentTasks', id }],
    }),
    
    // Health Check
    agentsHealthCheck: builder.query<any, void>({
      query: () => ({
        url: '/agents/health',
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetAgentsStatusQuery,
  useListAvailableAgentsQuery,
  useOrchestrateAgentsMutation,
  useGenerateCodeMutation,
  useGenerateTestsMutation,
  useDeployProjectMutation,
  useGetTaskStatusQuery,
  useLazyGetTaskStatusQuery,
  useAgentsHealthCheckQuery,
} = agentsAPI;
